import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { downloadUploadedDocument } from "utils/helpers/files";
import ActionButtons from "../Components/ActionButtons";
import DataProtection from "../Components/DataProtection";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DocumentUpload from "../Justification/DocumentUpload";
import validation from "./validation";

function View({
  project,
  initialValues,
  onSubmit,
  downloadFile,
  onBack,
  translate,
  onFileRemove: handleFileRemove,
}) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const { isValid, submitForm, setFieldValue, values, ...formProps } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: onSubmit,
      validationSchema: validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
      ),
    });

  const createFileRemoveHandler = (fieldName) => async (item) => {
    if (handleFileRemove) {
      await handleFileRemove(fieldName)(item);
      // Remove file from form values immediately
      const currentFiles = values[fieldName] || [];
      const updatedFiles = currentFiles.filter(
        (file) => (file?.uid || file?.id) !== (item?.uid || item?.id),
      );
      setFieldValue(fieldName, updatedFiles);
    }
  };

  const handleDownload = ({ uid, size, base64, contentType, name }) => {
    if (!size) return downloadFile(uid);
    downloadUploadedDocument({
      base64,
      contentType,
      name,
    });
  };

  return (
    <Layout>
      <Header
        title={
          translate?.HEADER?.TITLE ||
          "Les pièces justificatives de votre conjoint(e)"
        }
        highlight={translate?.HEADER?.HIGHLIGHT || "Pièces justificatives"}
        subtitle={
          translate?.HEADER?.SUBTITLE || "Pièces justificatives du conjoint"
        }
      />

      <div className="miltis-form">
        <div className="miltis-form__container">
          <DocumentUpload
            label={
              translate?.DOCUMENTS?.SOCIAL_SECURITY_CERTIFICATE?.LABEL ||
              "Attestation de droits de l'Assurance Maladie"
            }
            items={values.socialSecurityCertificate}
            onDownload={handleDownload}
            onUpload={(item) => {
              setFieldValue("socialSecurityCertificate", item);
            }}
            onFileRemove={createFileRemoveHandler("socialSecurityCertificate")}
            required={true}
            error={get(formProps.errors, "socialSecurityCertificate")}
          />
          <div className="recap__wrapper--info">
            <p>
              {translate?.FILE_INFO?.SUPPORTED_FORMATS ||
                "Formats de fichiers pris en charge : JPEG, PNG ou PDF"}
            </p>
            <p>{translate?.FILE_INFO?.MAX_SIZE || "Taille maximale : 5 Mo"}</p>
          </div>
          <ActionButtons
            disabled={!isEmpty(formProps.errors)}
            onNext={submitForm}
            onBack={onBack}
            buttonText={translate?.BUTTON?.NEXT || "Suivant"}
          />
          <DataProtection />
        </div>
      </div>
    </Layout>
  );
}

export default View;
